var _defs, _circle, _circle2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 8,
    x2: 56,
    y1: 8,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBEAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDBFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ball",
    x1: 16,
    x2: 48,
    y1: 18,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F97316"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 29,
    fill: "url(#bg)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 35,
    r: 18,
    fill: "url(#ball)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22C55E",
    d: "M15 34c10-2 20-8 28-17 4 4 6 9 6 15-9 9-19 15-31 17-2-4-3-9-3-15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M19 49c10-2 20-8 29-17 0 6-3 12-8 16s-13 5-21 1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EF4444",
    d: "M49 13c4 0 7 3 7 7s-3 7-7 7c-2 0-4-1-5-2l-5 5-5-5 5-5c-1-1-2-3-2-5 0-4 3-7 7-7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToys);
export default __webpack_public_path__ + "static/media/toys.9b63c0d0b6ea43c93b3a31e6d812e7b6.svg";
export { ForwardRef as ReactComponent };